export default "__VITE_ASSET__BsVzPBJl__"